import { TradingViewEmbed, widgetType } from "./TradingViewEmbed";

export { TradingViewEmbed, widgetType };
